<template>
  <div>
    <el-dialog :title="$t('system.assign_role')" :close-on-click-modal="false" :visible.sync="dialogUserVisible" class="diglog-card" width="800px" @close="initData">
      <div class="header-line" />
      <div style="margin: 20px 0">
        <div class="assign-role-dec">
          <p>{{ $t('system.role_details') }}</p>
        </div>
        <div class="assign-role-form">
          <el-form ref="form" :model="form" label-width="200px" :rules="rules" label-position="top">
            <div style="width: 200px; display: inline-block;margin-right: 20px;">
              <el-form-item :label="$t('system.role_name')+':'" prop="role_id">
                <el-radio-group v-model="form.role_id" :disabled="masterAccFlag" @change="handleChangeRole">
                  <div v-for="role in roleList">
                    <el-radio
                      :key="role.id"
                      :label="role.id"
                      style="margin-bottom: 10px"
                    >{{ role.role_name }}</el-radio>
                  </div>
                </el-radio-group>
              </el-form-item>
            </div>

            <div style="width: 500px; display: inline-block; vertical-align: top">
              <el-form-item :label="$t('system.authority')+':'" prop="role_auths">
                <SystemMchMenu
                  :menu-list="menuList"
                  :auth-list="checkAuths"
                  :modal-flag="3"
                />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogUserVisible = false">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" :disabled="listLoading" @click="submitAssignRole('form')">{{ $t('components.submit') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { assignRoleAuthorities, fetchMerchantRoles } from '@/api/system/system'
export default {
  name: 'AssignMchRoleModal',
  components: {
    SystemMchMenu: () => import('../System/SystemBaseMenu')
  },
  props: {
    menuList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialogUserVisible: false,
      listLoading: false,
      form: {
        mch_user_id: '',
        role_id: ''
      },
      masterAccFlag: true,
      roleList: [],
      checkAuths: [],
      // cities: cityOptions,
      rules: {},
      isIndeterminate: true,
      checkAll: false
    }
  },
  mounted() {
    this.$bus.off('UPDATE_CHECK_AUTH_MODAL')
    this.$bus.on('UPDATE_CHECK_AUTH_MODAL', (value) => {
      this.form.role_auths = value
    })
  },
  methods: {
    getMchRoleList(params = {}) {
      fetchMerchantRoles(params).then(res => {
        this.roleList = res.data
        this.roleList.forEach(item => {
          if (item.id === this.form.role_id) {
            this.checkAuths = item.auth_codes
          }
        })
      })
    },
    handleChangeRole() {
      this.checkAuths = []
      this.roleList.forEach(item => {
        if (item.id === this.form.role_id) {
          this.checkAuths = item.auth_codes
        }
      })
    },
    changeModalStatus(status, row) {
      this.dialogUserVisible = status
      this.form.role_id = row.role_id
      this.form.mch_user_id = row.id
      this.masterAccFlag = row.account_type === 1 && (row.role_id && row.role_id > 0)
      this.getMchRoleList()
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    },
    initData() {
      this.form = {
        role_id: '',
        mch_user_id: ''
      }
      this.checkAuths = []
    },
    submitAssignRole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.listLoading = true
            const params = {
              mch_user_id: this.form.mch_user_id,
              role_id: this.form.role_id
            }
            assignRoleAuthorities(params).then(res => {
              this.$message.success('Success')
              this.$emit('updateRoleList')
              this.dialogUserVisible = false
            }).finally(() => {
              this.listLoading = false
            })
          })
        }
      })
    },
    handleCheckAllChange() {

    },
    handleCheckedChange() {

    }
  }
}
</script>

<style scoped>
.assign-role-dec > p {
  font-style: normal;
  font-weight: 600;  font-family: 'Inter-SemiBold';
  font-size: 18px;
  line-height: 22px;
  color: #000000;
}

.assign-role-dec > span {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #7A869E;

}
.role-item-line {
  margin-top: 24px;
  border-bottom: 1px solid #D3D7DF;
}
.add-role-form {
  margin-top: 24px;
}
.checkboxItem{
  display: block;
  padding-left: 40px;
}
</style>
